module.exports = __webpack_public_path__ + "img/activityBg.158da01b.png";